import {
  Home,
  Droplets,
  Flame,
  Wind,
  Waves,
  Bath,
  Store,
  Mail,
  Cylinder,
  Shield,
  Plug,
  Package,
  CloudRain,
  SprayCan,
  Wrench,
  LayoutGrid,
  Sun,
  Settings,
  Box,
  Cpu,
  ListFilter,
  Tag,
  Calendar,
  Thermometer,
  Snowflake,
  Grid3x3,
  Flower2,
  Cog,
} from "lucide-react";

// Logo (nouveau logo EPP - fond noir)
export const EPP_LOGO = "/logo-epp.png";

/** Image de secours si l’API / le fichier image échoue (pages connexion & inscription). */
export const AUTH_PROMO_FALLBACK_IMAGE = "/images/showroom/01.webp";

// Images hébergées localement (public/images/)
export const EPP = {
  showroom1: "/showroom.png",
  showroom2: "/showroom.png",
  allia: "/images/brands/allia.webp",
  grohe: "/images/brands/grohe.webp",
  novellini: "/images/brands/novellini.webp",
  kinedo: "/images/brands/kinedo.webp",
  chappee: "/images/brands/chappee.webp",
  thermor: "/images/brands/thermor.webp",
  ariston: "/images/brands/ariston.webp",
  franke: "/images/brands/franke.webp",
  chaffoteaux: "/images/brands/chaffoteaux.webp",
  pellet: "/images/brands/pellet.webp",
  villeroy: "/images/brands/villeroy-boch.webp",
  acova: "/images/brands/acova.webp",
  irsap: "/images/brands/irsap.webp",
  atlantic: "/images/brands/atlantic.webp",
  fujitsu: "/images/brands/fujitsu.webp",
  giatsu: "/images/brands/giatsu.webp",
};

// All 16 brands
export const allBrands = [
  { name: "Allia", logo: EPP.allia, url: "https://abattantallia.com/" },
  { name: "Grohe", logo: EPP.grohe, url: "https://www.grohe.fr/fr_fr/" },
  { name: "Novellini", logo: EPP.novellini, url: "https://www.novellini.fr/" },
  { name: "Kinedo", logo: EPP.kinedo, url: "https://www.kinedo.com/" },
  { name: "Chappee", logo: EPP.chappee, url: "https://www.chappee.com/" },
  { name: "Thermor", logo: EPP.thermor, url: "https://www.thermor.fr/" },
  { name: "Ariston", logo: EPP.ariston, url: "https://www.ariston.com/fr-fr/" },
  {
    name: "Franke",
    logo: EPP.franke,
    url: "https://www.franke.com/fr/fr/home.html",
  },
  {
    name: "Chaffoteaux",
    logo: EPP.chaffoteaux,
    url: "https://chaffoteaux.fr/",
  },
  { name: "Pellet", logo: EPP.pellet, url: "https://www.pellet-asc.fr/fr/" },
  {
    name: "Villeroy & Boch",
    logo: EPP.villeroy,
    url: "https://www.villeroy-boch.fr/",
  },
  { name: "Acova", logo: EPP.acova, url: "https://www.acova.fr/" },
  { name: "Irsap", logo: EPP.irsap, url: "https://www.irsap.com/fr" },
  { name: "Atlantic", logo: EPP.atlantic, url: "https://www.atlantic.fr/" },
  { name: "Fujitsu", logo: EPP.fujitsu, url: "https://global.fujitsu/fr-fr" },
  { name: "Giatsu", logo: EPP.giatsu, url: "https://giatsu.com/es/" },
];

// Agencies
export const agencies = [
  {
    id: "mandelieu",
    name: "Euro Plomberie Piscines Mandelieu",
    city: "Mandelieu-la-Napoule",
    address: "Parc d'Activite de la Siagne, Av. Jean Mermoz, 06210 Mandelieu-la-Napoule",
    phone: "04 93 90 35 50",
    hours: "Lun-Ven : 07h30-12h00 / 13h30-17h00 · Sam : 08h00-12h00 · Dim : Ferme",
    isShowroom: false,
    locationType: "store",
    supportsClickCollect: true,
    image: "https://europlomberie-06.fr/uploads/media/images/cms/medias/thumb_/cms/medias/689ae7b470ccf_images_large.webp",
  },
  {
    id: "antibes",
    name: "Euro Plomberie Piscines Antibes",
    city: "Antibes",
    address: "400 Allee des Terriers emplacement n 15, 06600 Antibes",
    phone: "04 93 90 35 50",
    hours: "Lun-Ven : 07h30-12h00 / 13h30-17h00 · Sam : 08h00-12h00 · Dim : Ferme",
    isShowroom: false,
    locationType: "store",
    supportsClickCollect: true,
    image: "https://europlomberie-06.fr/uploads/media/images/cms/medias/thumb_/cms/medias/689ae60a380f5_images_large.webp",
  },
  {
    id: "mouans-sartoux",
    name: "Euro Plomberie Piscines Mouans-Sartoux",
    city: "Mouans-Sartoux",
    address: "425 Chemin de la Nartassiere, 06370 Mouans-Sartoux",
    phone: "04 93 90 35 50",
    hours: "Lun-Ven : 07h30-12h00 / 13h30-17h00 · Sam : 08h00-12h00 · Dim : Ferme",
    isShowroom: false,
    locationType: "store",
    supportsClickCollect: true,
    image: "https://europlomberie-06.fr/uploads/media/images/cms/medias/thumb_/cms/medias/689ae83ac3847_images_large.webp",
  },
  {
    id: "le-cannet",
    name: "Euro Plomberie Piscines Le Cannet",
    city: "Le Cannet",
    address: "33 Chemin des Fades, 06110 Le Cannet",
    phone: "04 93 90 35 50",
    hours: "Lun-Ven : 07h30-12h00 / 13h30-17h00 · Sam : 08h00-12h00 · Dim : Ferme",
    isShowroom: false,
    locationType: "store",
    supportsClickCollect: true,
    image: "https://europlomberie-06.fr/uploads/media/images/cms/medias/thumb_/cms/medias/689ae58ea22d1_images_large.webp",
  },
  {
    id: "gattieres",
    name: "Euro Plomberie Piscines Gattieres",
    city: "Gattieres",
    address: "Quartier de la, Avenue de la Tourre, 06510 Gattieres",
    phone: "04 93 90 35 50",
    hours: "Lun-Ven : 07h30-12h00 / 13h30-17h00 · Sam : 08h00-12h00 · Dim : Ferme",
    isShowroom: false,
    locationType: "store",
    supportsClickCollect: true,
    image: "https://europlomberie-06.fr/uploads/media/images/cms/medias/thumb_/cms/medias/689ae55e1d21b_images_large.webp",
  },
  {
    id: "showroom-le-cannet",
    name: "Showroom EPP Le Cannet",
    city: "Le Cannet",
    address: "12 chemin de l'industrie, 06110 Le Cannet",
    phone: "04 93 90 35 50",
    hours: "Lun-Ven : 08h30-12h00 / 13h30-17h30 · Sam : 08h00-12h00 · Dim : Ferme",
    isShowroom: true,
    locationType: "showroom",
    supportsClickCollect: false,
    description: "Showroom EPP (salle de bains, carrelage, amenagement)",
    image: "https://europlomberie-06.fr/uploads/media/images/cms/medias/thumb_/cms/medias/689ae811866cc_images_large.webp",
  },
];

// Navigation principale (header) — ordre distributeur pro B2B
export const navItems = [
  { name: "Accueil", path: "/", icon: Home },
  {
    name: "Plomberie",
    path: "/plomberie",
    icon: Droplets,
    megaMenuKey: "plomberie",
  },
  {
    name: "Chauffage",
    path: "/chauffage",
    icon: Flame,
    megaMenuKey: "chauffage",
  },
  {
    name: "Climatisation",
    path: "/climatisation",
    icon: Wind,
    megaMenuKey: "climatisation",
  },
  { name: "Piscines", path: "/piscines", icon: Waves, megaMenuKey: "piscines" },
  {
    name: "Salle de bains",
    path: "/salle-de-bains",
    icon: Bath,
    megaMenuKey: "salleDeBains",
  },
  {
    name: "Outillage",
    path: "/catalogue",
    icon: Wrench,
    megaMenuKey: "outillage",
  },
  { name: "Marques", path: "/partenaires", icon: Tag },
  {
    name: "Catalogue",
    path: "/catalogue",
    icon: LayoutGrid,
    isCatalogue: true,
  },
  { name: "Showroom", path: "/showroom", icon: Store },
  { name: "Événements", path: "/evenements", icon: Calendar },
  { name: "Contact", path: "/contact", icon: Mail },
];

// Sous-menus du mega menu desktop (liens B2B crédibles)
export const megaMenuSections = {
  plomberie: [
    { label: "Tubes & raccords", path: "/catalogue" },
    { label: "Multicouche", path: "/catalogue" },
    { label: "Cuivre", path: "/catalogue" },
    { label: "PVC", path: "/catalogue" },
    { label: "Robinetterie", path: "/catalogue" },
    { label: "Vannes", path: "/catalogue" },
    { label: "Pompes", path: "/catalogue" },
    { label: "Traitement de l'eau", path: "/catalogue" },
  ],
  chauffage: [
    { label: "Chaudières", path: "/catalogue" },
    { label: "Radiateurs", path: "/catalogue" },
    { label: "Sèche-serviettes", path: "/catalogue" },
    { label: "Circulateurs", path: "/catalogue" },
    { label: "Régulation", path: "/catalogue" },
    { label: "Plancher chauffant", path: "/catalogue" },
  ],
  climatisation: [
    { label: "Split mural", path: "/catalogue" },
    { label: "Multi-split", path: "/catalogue" },
    { label: "Gainable", path: "/catalogue" },
    { label: "Accessoires", path: "/catalogue" },
    { label: "Entretien", path: "/catalogue" },
  ],
  piscines: [
    { label: "Filtration", path: "/catalogue" },
    { label: "Pompes", path: "/catalogue" },
    { label: "Traitement eau", path: "/catalogue" },
    { label: "Nettoyage", path: "/catalogue" },
    { label: "Chauffage piscine", path: "/catalogue" },
    { label: "Accessoires bassin", path: "/catalogue" },
  ],
  salleDeBains: [
    { label: "Meubles", path: "/catalogue" },
    { label: "Vasques", path: "/catalogue" },
    { label: "WC", path: "/catalogue" },
    { label: "Douches", path: "/catalogue" },
    { label: "Receveurs", path: "/catalogue" },
    { label: "Robinetterie", path: "/catalogue" },
  ],
  outillage: [
    { label: "Outillage main", path: "/catalogue" },
    { label: "Outillage chantier", path: "/catalogue" },
    { label: "Coupe", path: "/catalogue" },
    { label: "Mesure", path: "/catalogue" },
    { label: "Fixation", path: "/catalogue" },
    { label: "Consommables", path: "/catalogue" },
  ],
};

// --- Header 3 niveaux (bandeau, ligne principale, nav secondaire) ---

/** Bandeau fin supérieur (niveau A) */
export const topBarLinks = [
  { label: "5 agences de retrait + showroom Le Cannet", path: "/#agences" },
  {
    label: "Choisir mon agence",
    path: "/#agences",
    highlight: true,
    openAgencyPopup: true,
  },
  { label: "Demander un devis", path: "/contact" },
  { label: "Promotions", path: "/promos" },
  { label: "Événements", path: "/evenements" },
  { label: "Contact", path: "/contact" },
];

/** Barre de navigation secondaire (niveau 1) — menu principal épuré */
export const secondaryNavItems = [
  { label: "Catalogue", path: "/catalogue", isProduits: true },
  { label: "Nos Agences", path: "/agences" },
  { label: "Nos Partenaires", path: "/partenaires" },
  { label: "Événements", path: "/evenements", isBrandBlue: true },
  { label: "Showroom", path: "/showroom", isHighlight: true },
  { label: "Promotions", path: "/promos", isCta: true },
  { label: "Contact", path: "/contact" },
];

/** Drawer niveau 1 — entrées principales (Catalogue = grandes familles niveau 2) */
export const drawerPrimaryItems = {
  main: [
    { id: "catalogue", label: "CATALOGUE", hasSub: true },
    { id: "agences", label: "NOS AGENCES", path: "/agences" },
    { id: "partenaires", label: "NOS PARTENAIRES", path: "/partenaires" },
    { id: "evenements", label: "ÉVÉNEMENTS", path: "/evenements", isBrandBlue: true },
    { id: "showroom", label: "SHOWROOM", path: "/showroom", isHighlight: true },
    { id: "promotions", label: "PROMOTIONS", path: "/promos", isCta: true },
    { id: "contact", label: "CONTACT", path: "/contact" },
  ],
  account: [
    { id: "devis", label: "Mes devis", path: "/compte/devis" },
    { id: "commandes", label: "Mes commandes", path: "/compte/commandes" },
    { id: "listes", label: "Mes listes de favoris", path: "/compte/favoris" },
  ],
};

/** Niveau 2 — grandes familles catalogue (une seule source de vérité) */
export const catalogueFamilies = [
  { id: "plomberie", label: "Plomberie", panelKey: "plomberie", path: "/catalogue/plomberie", image: "/images/categories/faucet.svg" },
  { id: "chauffage", label: "Chauffage", panelKey: "chauffage", path: "/catalogue/chauffage", image: "/images/categories/water-heater.svg" },
  { id: "climatisation", label: "Climatisation", panelKey: "climatisation", path: "/catalogue/climatisation", image: "/images/categories/cooling.svg" },
  { id: "sanitaire", label: "Sanitaire", panelKey: "sanitaire", path: "/catalogue/sanitaire", image: "/images/categories/bathtub.svg" },
  { id: "carrelage", label: "Carrelage", panelKey: "carrelage", path: "/catalogue/carrelage", image: "/images/categories/tile.svg" },
  { id: "piscine", label: "Piscine", panelKey: "piscine", path: "/catalogue/piscine", image: "/images/categories/pool.svg" },
  { id: "jardin", label: "Jardin", panelKey: "jardin", path: "/catalogue/jardin", image: "/images/categories/hose.svg" },
  { id: "outillage", label: "Outillage", panelKey: "outillage", path: "/catalogue/outillage", image: "/images/categories/table-saw.svg" },
  { id: "pieces-detachees", label: "Pièces détachées", panelKey: "pieces-detachees", path: "/catalogue/pieces-detachees", image: "/images/categories/spare-parts.svg" },
];

/** Niveau 3 — sous-catégories par famille (cataloguePanels) */
export const cataloguePanels = {
  plomberie: {
    title: "Plomberie",
    viewAllLabel: "Plomberie - Voir tout",
    viewAllPath: "/catalogue/plomberie",
    columns: [
      {
        title: "Plomberie",
        links: [
          { label: "Tubes et raccords", path: "/catalogue" },
          { label: "Multicouche", path: "/catalogue" },
          { label: "Cuivre", path: "/catalogue" },
          { label: "PVC évacuation", path: "/catalogue" },
          { label: "Vannes", path: "/catalogue" },
          { label: "Pompes", path: "/catalogue" },
          { label: "Traitement de l'eau", path: "/catalogue" },
        ],
      },
    ],
    featured: { title: "Plomberie", text: "Tubes, raccords, vannes.", ctaLabel: "Voir tout", ctaPath: "/catalogue/plomberie" },
  },
  chauffage: {
    title: "Chauffage",
    viewAllLabel: "Chauffage - Voir tout",
    viewAllPath: "/catalogue/chauffage",
    columns: [
      {
        title: "Chauffage",
        links: [
          { label: "Chauffage central", path: "/catalogue" },
          { label: "Radiateurs", path: "/catalogue" },
          { label: "Pompes à chaleur", path: "/catalogue" },
          { label: "Chaudières", path: "/catalogue" },
          { label: "Chauffe-eau", path: "/catalogue" },
          { label: "Plancher chauffant", path: "/catalogue" },
          { label: "Accessoires chauffage", path: "/catalogue" },
        ],
      },
    ],
    featured: { title: "Chauffage", text: "Chaudières, PAC, radiateurs.", ctaLabel: "Voir tout", ctaPath: "/catalogue/chauffage" },
  },
  climatisation: {
    title: "Climatisation",
    viewAllLabel: "Climatisation - Voir tout",
    viewAllPath: "/catalogue/climatisation",
    columns: [
      {
        title: "Climatisation",
        links: [
          { label: "Climatisation", path: "/catalogue" },
          { label: "Multi-split", path: "/catalogue" },
          { label: "Gainable", path: "/catalogue" },
          { label: "VMC", path: "/catalogue" },
          { label: "Ventilation", path: "/catalogue" },
          { label: "Accessoires clim", path: "/catalogue" },
        ],
      },
    ],
    featured: { title: "Climatisation", text: "Splits, gainable, VMC.", ctaLabel: "Voir tout", ctaPath: "/catalogue/climatisation" },
  },
  sanitaire: {
    title: "Sanitaire",
    viewAllLabel: "Sanitaire - Voir tout",
    viewAllPath: "/catalogue/sanitaire",
    columns: [
      {
        title: "Sanitaire",
        links: [
          { label: "Sanitaires", path: "/catalogue" },
          { label: "Douches et receveurs", path: "/catalogue" },
          { label: "Robinetterie salle de bains", path: "/catalogue" },
          { label: "Robinetterie cuisine", path: "/catalogue" },
          { label: "Meubles salle de bains", path: "/catalogue" },
          { label: "WC", path: "/catalogue" },
          { label: "Accessoires salle de bains", path: "/catalogue" },
        ],
      },
    ],
    featured: { title: "Sanitaire", text: "Sanitaires, douches, robinetterie.", ctaLabel: "Voir tout", ctaPath: "/catalogue/sanitaire" },
  },
  carrelage: {
    title: "Carrelage",
    viewAllLabel: "Carrelage - Voir tout",
    viewAllPath: "/catalogue/carrelage",
    columns: [
      {
        title: "Carrelage",
        links: [
          { label: "Carrelage intérieur", path: "/catalogue" },
          { label: "Carrelage extérieur", path: "/catalogue" },
          { label: "Faïence murale", path: "/catalogue" },
          { label: "Mosaïque", path: "/catalogue" },
          { label: "Colles et joints", path: "/catalogue" },
          { label: "Outillage carrelage", path: "/catalogue" },
        ],
      },
    ],
    featured: { title: "Carrelage", text: "Sol, mural, faïence.", ctaLabel: "Voir tout", ctaPath: "/catalogue/carrelage" },
  },
  piscine: {
    title: "Piscine",
    viewAllLabel: "Piscine - Voir tout",
    viewAllPath: "/catalogue/piscine",
    columns: [
      {
        title: "Piscine",
        links: [
          { label: "Filtration piscine", path: "/catalogue" },
          { label: "Pompes piscine", path: "/catalogue" },
          { label: "Traitement eau piscine", path: "/catalogue" },
          { label: "Robots piscine", path: "/catalogue" },
          { label: "Chauffage piscine", path: "/catalogue" },
          { label: "Accessoires piscine", path: "/catalogue" },
        ],
      },
    ],
    featured: { title: "Piscine", text: "Filtration, traitement, accessoires.", ctaLabel: "Voir tout", ctaPath: "/catalogue/piscine" },
  },
  jardin: {
    title: "Jardin",
    viewAllLabel: "Jardin - Voir tout",
    viewAllPath: "/catalogue/jardin",
    columns: [
      {
        title: "Jardin",
        links: [
          { label: "Arrosage", path: "/catalogue" },
          { label: "Pompes jardin", path: "/catalogue" },
          { label: "Tuyaux et raccords", path: "/catalogue" },
          { label: "Aménagement extérieur", path: "/catalogue" },
          { label: "Entretien jardin", path: "/catalogue" },
        ],
      },
    ],
    featured: { title: "Jardin", text: "Arrosage, aménagement.", ctaLabel: "Voir tout", ctaPath: "/catalogue/jardin" },
  },
  outillage: {
    title: "Outillage",
    viewAllLabel: "Outillage - Voir tout",
    viewAllPath: "/catalogue/outillage",
    columns: [
      {
        title: "Outillage",
        links: [
          { label: "Outillage à main", path: "/catalogue" },
          { label: "Outillage électroportatif", path: "/catalogue" },
          { label: "Fixation", path: "/catalogue" },
          { label: "Consommables", path: "/catalogue" },
          { label: "Équipement de protection", path: "/catalogue" },
        ],
      },
    ],
    featured: { title: "Outillage", text: "Main, électroportatif, fixation.", ctaLabel: "Voir tout", ctaPath: "/catalogue/outillage" },
  },
  "pieces-detachees": {
    title: "Pièces détachées",
    viewAllLabel: "Pièces détachées - Voir tout",
    viewAllPath: "/catalogue/pieces-detachees",
    columns: [
      {
        title: "Pièces détachées",
        links: [
          { label: "Pièces chaudière", path: "/catalogue" },
          { label: "Pièces chauffe-eau", path: "/catalogue" },
          { label: "Pièces WC", path: "/catalogue" },
          { label: "Pièces robinetterie", path: "/catalogue" },
          { label: "Pièces clim", path: "/catalogue" },
          { label: "Joints et réparation", path: "/catalogue" },
        ],
      },
    ],
    featured: { title: "Pièces détachées", text: "Chaudière, chauffe-eau, robinetterie.", ctaLabel: "Voir tout", ctaPath: "/catalogue/pieces-detachees" },
  },
};

/** @deprecated Utiliser catalogueFamilies + cataloguePanels. Conservé pour compatibilité Header. */
export const drawerCategoryPanels = cataloguePanels;

/** Drawer catalogue CEDEO — panneau promo (colonne droite 320px) */
export const catalogueDrawerPromo = {
  image: "/showroom.png",
  title: "Découvrez notre showroom",
  ctaLabel: "Je découvre",
  ctaPath: "/showroom",
};

// Showroom gallery (images hébergées dans public/images/showroom/)
export const showroomGallery = [
  "/images/showroom/01.webp",
  "/images/showroom/02.webp",
  "/images/showroom/03.webp",
  "/images/showroom/04.webp",
  "/images/showroom/05.webp",
  "/images/showroom/06.webp",
  "/images/showroom/07.webp",
  "/images/showroom/08.webp",
  "/images/showroom/09.webp",
  "/images/showroom/10.webp",
  "/images/showroom/11.webp",
  "/images/showroom/12.webp",
  "/images/showroom/13.webp",
  "/images/showroom/14.webp",
  "/images/showroom/15.webp",
  "/images/showroom/16.webp",
  "/images/showroom/17.webp",
  "/images/showroom/18.webp",
  "/images/showroom/19.webp",
];

// Service pages data
export const servicePages = {
  plomberie: {
    slug: "plomberie",
    title: "Votre sp\u00E9cialiste en tubes, raccords et accessoires",
    marquee: "Mat\u00E9riel de plomberie professionnel",
    heroImage:
      "https://europlomberie-06.fr/uploads/media/images/cms/medias/thumb_/cms/medias/689b29020cbec_images_large.webp",
    intro: {
      title:
        "Vente de mat\u00E9riel de plomberie : robinetterie, tubes, raccords\u2026",
      text: [
        "Euro Plomberie Piscines, c'est 5 agences de retrait plomberie (Mandelieu, Mouans-Sartoux, Antibes, Le Cannet, Gatti\u00E8res) et un showroom d'exposition de 600 m\u00B2 au Cannet (salle de bains, am\u00E9nagement) \u2014 distinct du point de retrait commandes.",
        "Vous y trouverez un large choix de mat\u00E9riel de plomberie de qualit\u00E9 pour tous vos travaux de raccordement de r\u00E9seaux, mise en place de canalisations ou r\u00E9novations.",
        "Nos \u00E9quipes sont l\u00E0 pour vous conseiller et vous aider dans toutes vos d\u00E9marches.",
      ],
    },
    sections: [
      {
        title: "Tubes et raccords",
        text: "Que ce soit en cuivre, laiton ou en multicouche, notre large \u00E9ventail de tubes et de raccords est \u00E0 votre disposition dans toutes nos agences de retrait. Nos \u00E9quipes r\u00E9pondront \u00E0 vos besoins pour r\u00E9aliser au mieux tous vos chantiers.",
        icon: Cylinder,
      },
      {
        title: "Protection de r\u00E9seaux",
        text: "Afin de prot\u00E9ger les r\u00E9seaux de plomberie et de chauffage, de nombreux accessoires sont en libre-service en agence. Du mat\u00E9riel comme les r\u00E9ducteurs de pression, soupapes de s\u00FBret\u00E9 et r\u00E9gulateurs permettent de r\u00E9aliser les installations en toute s\u00E9curit\u00E9.",
        icon: Shield,
      },
      {
        title: "Branchement des r\u00E9seaux",
        text: "Pour l'alimentation et l'\u00E9vacuation de l'eau, profitez de tous les outils et accessoires de plomberie pour vous aider dans le branchement ou la modification du r\u00E9seau de plomberie.",
        icon: Plug,
      },
      {
        title: "Gaz",
        text: "Pour toutes vos installations au gaz : naturel, propane ou butane, vous trouverez tout le mat\u00E9riel dont vous aurez besoin du compteur gaz jusqu'au flexible en passant par tous les types de raccord.",
        icon: Flame,
      },
      {
        title: "Cuves",
        text: "Vous \u00EAtes \u00E0 la recherche d'un r\u00E9cup\u00E9rateur d'eau de pluie ? Vous avez besoin d'une citerne de stockage pour le gaz ? Nos cuves \u00E0 eau et \u00E0 gaz r\u00E9pondent \u00E0 vos besoins.",
        icon: Package,
      },
      {
        title: "Goutti\u00E8res",
        text: "Nos nombreuses r\u00E9f\u00E9rences de goutti\u00E8res en zinc, cuivre ou PVC vous aideront dans la mise en place de la zinguerie et dans l'\u00E9vacuation des eaux pluviales de la toiture.",
        icon: CloudRain,
      },
      {
        title: "Droguerie",
        text: "Au rayon droguerie, les produits d'entretien, de nettoyage ainsi que les mastics et produits de graissage facilitent vos t\u00E2ches quotidiennes.",
        icon: SprayCan,
      },
      {
        title: "Outillage",
        text: "Nos outils et accessoires professionnels vous faciliteront la t\u00E2che lors de travaux de plomberie. Sertisseuse, cintreuse\u2026 sont en rayon dans nos agences.",
        icon: Wrench,
      },
    ],
    brands: ["Allia", "Grohe", "Novellini", "Kinedo"],
    nextService: {
      title: "Chauffage performant et solutions adapt\u00E9es",
      desc: "D\u00E9couvrez notre large gamme de mat\u00E9riels de chauffage pour tous vos projets.",
      link: "/chauffage",
      label: "Chauffage",
    },
    color: "#190276",
    icon: Droplets,
  },
  chauffage: {
    slug: "chauffage",
    title:
      "Votre confort thermique assur\u00E9 avec des \u00E9quipements de qualit\u00E9",
    marquee: "Solution de chauffage",
    heroImage:
      "https://europlomberie-06.fr/uploads/media/images/cms/medias/thumb_/cms/medias/689b2e2dd5585_images_large.webp",
    intro: {
      title:
        "Chauffagiste exp\u00E9riment\u00E9 pour votre pompe \u00E0 chaleur, chaudi\u00E8re\u2026",
      text: [
        "Apportez une chaleur douce \u00E0 l'int\u00E9rieur d'un logement individuel ou d'un habitat collectif gr\u00E2ce au mat\u00E9riel de chauffage disponible dans nos agences de retrait.",
        "Notre catalogue est compos\u00E9 de solutions des plus grandes marques (CHAPPEE, THERMOR, ARISTON\u2026). Ce mat\u00E9riel de haute qualit\u00E9 vous permet de b\u00E9n\u00E9ficier des derni\u00E8res innovations technologiques.",
      ],
    },
    sections: [
      {
        title: "Pompe \u00E0 chaleur",
        text: "Notre large choix de pompes \u00E0 chaleur permet de r\u00E9pondre aux besoins de vos clients. Nous vous guidons parmi les diff\u00E9rents mod\u00E8les de PAC de nos fournisseurs comme CHAPPEE, THERMOR, ARISTON.",
        icon: Wind,
      },
      {
        title: "Chaudi\u00E8re",
        text: "Nous disposons d'un grand nombre de mod\u00E8les de chaudi\u00E8res r\u00E9pondant aux besoins de votre client\u00E8le. La gamme de chaudi\u00E8res basse consommation les rend \u00E9ligibles aux demandes de cr\u00E9dit d'imp\u00F4ts.",
        icon: Flame,
      },
      {
        title: "Chauffe-eau",
        text: "Il est facile d'obtenir une production d'eau chaude \u00E9conomique gr\u00E2ce aux solutions de chauffe-eau \u00E9lectrique, thermodynamique ou solaire. Du chauffe-eau d'appoint au chauffe-eau intelligent et connect\u00E9.",
        icon: Droplets,
      },
      {
        title: "Plancher chauffant",
        text: "Nous vous offrons une solution de confort pour installer un plancher chauffant performant. Les mod\u00E8les permettent de g\u00E9rer la temp\u00E9rature pi\u00E8ce par pi\u00E8ce.",
        icon: LayoutGrid,
      },
      {
        title: "Radiateur",
        text: "Nous assurons aussi la vente de radiateurs \u00E9lectriques et \u00E0 eau. Les derniers mod\u00E8les r\u00E9duisent la consommation d'\u00E9nergie et apportent un confort en toutes circonstances.",
        icon: Sun,
      },
      {
        title: "S\u00E8che-serviettes",
        text: "Notre gamme de s\u00E8che-serviettes r\u00E9pond \u00E0 vos envies de confort dans la salle de bains. Raccord\u00E9s \u00E0 la chaudi\u00E8re ou au r\u00E9seau \u00E9lectrique, nos mod\u00E8les design disposent de nombreuses fonctionnalit\u00E9s.",
        icon: Bath,
      },
      {
        title: "Accessoires chauffage et fumisterie",
        text: "Nous vous proposons toute une gamme de conduits de fum\u00E9e, conduits de chemin\u00E9es et accessoires de tubage afin de r\u00E9aliser un raccordement de chauffage en toute s\u00E9curit\u00E9.",
        icon: Settings,
      },
    ],
    brands: ["Chappee", "Thermor", "Ariston"],
    nextService: {
      title: "Climatisation r\u00E9versible \u2013 Confort toute l'ann\u00E9e",
      desc: "D\u00E9couvrez nos solutions performantes et \u00E9conomiques pour rafra\u00EEchir ou chauffer votre int\u00E9rieur.",
      link: "/climatisation",
      label: "Climatisation",
    },
    color: "#f7040a",
    icon: Flame,
  },
  climatisation: {
    slug: "climatisation",
    title:
      "Climatisation r\u00E9versible et syst\u00E8mes de confort thermique",
    marquee: "Syst\u00E8me de climatisation",
    heroImage:
      "https://europlomberie-06.fr/uploads/media/images/cms/medias/thumb_/cms/medias/689b3450c982b_images_large.webp",
    intro: {
      title: "La Climatisation monosplit ou multisplit, gainable ou VRV\u2026",
      text: [
        "Profitez de nombreux mod\u00E8les de climatiseurs r\u00E9versibles pour donner un air froid l'\u00E9t\u00E9 et un air chaud l'hiver.",
        "Nous disposons d'un large stock de diff\u00E9rentes marques : FUJITSU, GIATSU, CHAPP\u00C9E.",
      ],
    },
    sections: [
      {
        title: "La climatisation murale",
        text: "Tr\u00E8s compact et discret, le climatiseur mural s'installe facilement dans une habitation ou un bureau. Il est possible d'installer des solutions monosplit ou multisplit afin de s'adapter \u00E0 tous les espaces.",
        icon: Box,
      },
      {
        title: "La climatisation multisplit",
        text: "Le syst\u00E8me de climatisation multisplit r\u00E9versible est une excellente mani\u00E8re de remplacer un syst\u00E8me de chauffage classique tout en profitant d'un air frais l'\u00E9t\u00E9. Pouvant \u00EAtre connect\u00E9 \u00E0 plusieurs unit\u00E9s int\u00E9rieures sur une unit\u00E9 ext\u00E9rieure.",
        icon: LayoutGrid,
      },
      {
        title: "La climatisation gainable",
        text: "Installez une climatisation presque invisible en profitant de la pose d'un climatiseur gainable. Connect\u00E9e \u00E0 une pompe \u00E0 chaleur air-air, l'unit\u00E9 int\u00E9rieure est dissimul\u00E9e dans les combles ou un faux plafond.",
        icon: Wind,
      },
      {
        title: "Le VRF ou VRV",
        text: "Avec climatisation variable et syst\u00E8me de pilotage intelligent, les syst\u00E8mes de climatisation permettent de r\u00E9guler la temp\u00E9rature dans les b\u00E2timents tertiaires de mani\u00E8re autonome.",
        icon: Cpu,
      },
    ],
    brands: ["Chappee", "Fujitsu", "Giatsu"],
    nextService: {
      title: "Piscines & \u00E9quipements \u2013 Tout pour votre oasis",
      desc: "D\u00E9couvrez notre gamme compl\u00E8te de mat\u00E9riel de piscine.",
      link: "/piscines",
      label: "Piscines",
    },
    color: "#190276",
    icon: Wind,
  },
  piscines: {
    slug: "piscines",
    title: "Solutions professionnelles pour filtration, robots et traitement",
    marquee: "\u00C9quipements de piscine",
    heroImage:
      "https://europlomberie-06.fr/uploads/media/images/cms/medias/thumb_/cms/medias/689b07a13e781_images_large.webp",
    intro: {
      title:
        "La piscine : robots, \u00E9quipements pour filtrations et traitement de l'eau",
      text: [
        "Sp\u00E9cialiste de la piscine depuis plus de 25 ans, Euro Plomberie Piscines dispose de mat\u00E9riel garanti et s\u00E9lectionn\u00E9 avec le plus grand soin.",
        "Rendez-vous dans l'une de nos agences de retrait pour le mat\u00E9riel et les conseils pro ; le showroom du Cannet pour d\u00E9couvrir salles de bains et ambiances.",
      ],
    },
    sections: [
      {
        title: "Mat\u00E9riel de filtration",
        text: "Gardez une eau pure pour une excellente baignade. Que vous souhaitiez installer ou remplacer un groupe de filtration, un filtre \u00E0 sable ou une pompe, nous vous guidons dans le choix d'un \u00E9quipement de qualit\u00E9.",
        icon: ListFilter,
      },
      {
        title: "Les robots de piscine",
        text: "Le robot de piscine effectue un nettoyage efficace et vous fait gagner du temps. Diff\u00E9rents mod\u00E8les existent : robot hydraulique, robot \u00E9lectrique \u00E0 batterie, robot pulseur.",
        icon: Settings,
      },
      {
        title: "Traitement de l'eau",
        text: "Entretenez facilement votre piscine en s\u00E9lectionnant les meilleurs produits de traitement de l'eau. Purification au chlore ou \u00E0 l'oxyg\u00E8ne actif, \u00E9lectrolyseur, r\u00E9gulation automatique du pH.",
        icon: Droplets,
      },
    ],
    brands: [],
    nextService: {
      title: "D\u00E9couvrez notre Showroom",
      desc: "Explorez nos installations mises en sc\u00E8ne pour visualiser les produits en situation.",
      link: "/showroom",
      label: "Showroom",
    },
    color: "#190276",
    icon: Waves,
  },
  "salle-de-bains": {
    slug: "salle-de-bains",
    title:
      "Robinetterie, meubles, baignoires, receveurs\u2026 tout est l\u00E0",
    marquee: "Mat\u00E9riel de salle de bains",
    heroImage:
      "https://europlomberie-06.fr/uploads/media/images/cms/medias/thumb_/cms/medias/689b0d1d946d0_images_large.webp",
    intro: {
      title:
        "Sp\u00E9cialiste en mat\u00E9riel de salle de bains et sanitaires",
      text: [
        "Que vous soyez professionnel ou particulier, si vous souhaitez r\u00E9aliser l'installation ou la r\u00E9novation d'une salle de bains, faites appel \u00E0 nos services.",
        "D\u00E9couvrez le mat\u00E9riel provenant des plus grandes marques, comme Allia, Grohe, Novellini, Kinedo, etc., disponible imm\u00E9diatement ou sur catalogue.",
      ],
    },
    sections: [
      {
        title: "La robinetterie",
        text: "\u00C9quipez votre salle de bains et toute votre maison avec des robinets. Retrouvez une gamme compl\u00E8te de mitigeurs, m\u00E9langeurs et colonnes de douche.",
        icon: Droplets,
      },
      {
        title: "Les baignoires",
        text: "La baignoire est un \u00E9l\u00E9ment de d\u00E9coration \u00E0 part enti\u00E8re, gr\u00E2ce \u00E0 sa forme et sa mati\u00E8re. Notre large collection vous permet de choisir la baignoire qui vous correspond, qu'elle soit \u00E0 encastrer ou en \u00EElot.",
        icon: Bath,
      },
      {
        title: "Les receveurs de douche",
        text: "Alternative \u00E0 la cabine de douche, le receveur apporte confort et style. Il existe des mod\u00E8les antid\u00E9rapants et adapt\u00E9s aux personnes \u00E0 mobilit\u00E9 r\u00E9duite.",
        icon: Box,
      },
      {
        title: "Les parois de douche",
        text: "Plus pratique et hygi\u00E9nique qu'un rideau, la paroi de douche se d\u00E9cline en versions pivotantes, fixes ou coulissantes pour s'adapter \u00E0 tous les espaces.",
        icon: LayoutGrid,
      },
      {
        title: "Les meubles de salle de bains",
        text: "D\u00E9couvrez notre gamme compl\u00E8te de meubles, plans, colonnes et armoires de toilette. Ces meubles peuvent \u00EAtre \u00E9quip\u00E9s d'accessoires comme miroirs ou \u00E9clairages.",
        icon: Package,
      },
      {
        title: "Les lavabos et vasques",
        text: "Trouvez la vasque ou le lavabo qui s'int\u00E8gre parfaitement \u00E0 votre int\u00E9rieur. Notre s\u00E9lection inclut du mat\u00E9riel \u00E0 poser ou \u00E0 encastrer, au design \u00E9l\u00E9gant.",
        icon: Sun,
      },
      {
        title: "L'espace toilettes",
        text: "Am\u00E9nagez votre espace toilettes avec diff\u00E9rentes options : cuvette suspendue, au sol\u2026 Nous proposons \u00E9galement toutes les pi\u00E8ces d\u00E9tach\u00E9es n\u00E9cessaires.",
        icon: Settings,
      },
      {
        title: "Les accessoires et outils",
        text: "En tant que grossiste, nous fournissons une large vari\u00E9t\u00E9 d'accessoires et d'outils pour r\u00E9ussir l'installation de vos sanitaires.",
        icon: Wrench,
      },
    ],
    brands: ["Allia", "Grohe", "Novellini", "Kinedo"],
    nextService: {
      title: "Tout le mat\u00E9riel plomberie dont vous avez besoin !",
      desc: "D\u00E9couvrez notre large gamme de tubes, raccords, outillage et accessoires.",
      link: "/plomberie",
      label: "Plomberie",
    },
    color: "#F2B531",
    icon: Bath,
  },
};

// Opening hours
export const openingHours = [
  { day: "Lundi", hours: "07:30 - 12:00 / 13:30 - 17:00" },
  { day: "Mardi", hours: "07:30 - 12:00 / 13:30 - 17:00" },
  { day: "Mercredi", hours: "07:30 - 12:00 / 13:30 - 17:00" },
  { day: "Jeudi", hours: "07:30 - 12:00 / 13:30 - 17:00" },
  { day: "Vendredi", hours: "07:30 - 12:00 / 13:30 - 17:00" },
  { day: "Samedi", hours: "08:00 - 12:00" },
];

// Contact info
export const contactInfo = {
  address: "33 Chemin des Fades, 06110 Le Cannet",
  phone1: "04 93 90 35 50",
  phone2: "06 65 94 84 81",
  email: "contact@epp6.fr",
};

// Lien vers les avis Google (à remplacer par l'URL de votre fiche Google Business / Maps)
export const googleReviewsUrl =
  "https://www.google.com/maps/search/Euro+Plomberie+Piscines+Le+Cannet";
